import { FormLabel } from '@data-delivery/d3s';
import { AssignmentProductsCsvDropzone } from './assignment-products-csv-dropzone';
import { ProductSelectGrid } from './product-select-grid';

interface ProductsSectionProps {
  selected: string[];
  businessGroupId: string | undefined;
  isEditMode: boolean;
  pending?: boolean;
  onChange: (next: string[]) => void;
}

export function ProductsSection({
  selected,
  businessGroupId,
  isEditMode,
  pending,
  onChange,
}: ProductsSectionProps) {
  return (
    <div className='flex flex-col gap-2 md:col-span-2'>
      <FormLabel>Products</FormLabel>
      <AssignmentProductsCsvDropzone
        products={selected}
        businessGroupId={businessGroupId}
        isEditMode={isEditMode}
        onBulkAddProducts={ids => {
          if (!ids.length) {
            return;
          }

          const next = Array.from(new Set([...selected, ...ids]));
          onChange(next);
        }}
        onBulkRemoveProducts={ids => {
          if (!ids.length) {
            return;
          }

          const next = selected.filter(id => !ids.includes(id));
          onChange(next);
        }}
        className='mb-2'
      />
      <ProductSelectGrid
        businessGroupId={businessGroupId}
        selected={selected}
        onChange={onChange}
        disabled={pending}
      />
    </div>
  );
}
